import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const ForecastInput = () => {
  const { forecastId = '' } = useParams();
  const decodedId = forecastId ? atob(forecastId) : forecastId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'forecast';

  useEffect(() => {
    if (forecastId) { setIsEditing(true); fetchDetails(); }
  }, [forecastId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['forecast'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Forecast details:', error); }
  };

  const fields = [
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'date', label: 'Date', type: 'date', required: true },
    { name: 'value', label: 'Value', type: 'number', required: true }
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Forecast' : 'Create Forecast'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/reporting/forecast/list" />
    </div>
  );
};

export default ForecastInput;
